import { isElementNode, isTag, isTextNode } from 'anodum';
import { IMAGE_SELECTOR } from '../../hdrm/constants/image-selector';
import findNextNode from './find-next-node';
import findPrevNode from './find-prev-node';
import { BACKSPACE_KEY, DELETE_KEY } from '../constants/keys';
import getCollapsedNodeAndOffset from './get-collapsed-node-and-offset';
import getElementFromNode from './get-element-from-node';
import findRootEditableElement from './find-root-editable-element';
import { LIST_ITEM } from '../constants/editable-elements';
import removeTextSiblings from './remove-text-siblings';

const handleRemoveImage = (e) => {
  const [node, offset] = getCollapsedNodeAndOffset();

  const editableElement = findRootEditableElement(node);
  if (!editableElement || isTag(editableElement, LIST_ITEM)) return false;

  const anchorElement = getElementFromNode(node);
  if (!anchorElement) return false;
  const rootNode = anchorElement.closest('[contenteditable]');

  let targetNode;

  switch (e.key) {
    case BACKSPACE_KEY: {
      if (offset !== 0) return false;
      targetNode = findPrevNode(node, rootNode);
      break;
    }
    case DELETE_KEY: {
      if (isTextNode(node) && node.data.length !== offset) return false;
      targetNode = findNextNode(node, rootNode);
      break;
    }
    default:
  }
  if (!targetNode || !isElementNode(targetNode)) return false;

  const imageNode = targetNode.closest(IMAGE_SELECTOR);
  if (!imageNode) return false;

  e.preventDefault();

  removeTextSiblings(imageNode);
  imageNode.remove();

  return true;
};

export default handleRemoveImage;
